import React, {Component} from 'react';
import FilterSlider from "./FilterSlider"
import FilterCheckboxes from "./FilterCheckboxes"
import FilterInput from "./FilterInput"
import FilterHelper from "../classes/FilterHelper";
import ActiveFilters from "../components/ActiveFilters";
import { Trans } from 'react-i18next';
import Icon from "./Icon";

class FilterColumn extends Component {
  constructor(props, context) {
    super(props, context);
    this.filterHelper = new FilterHelper();
  }


  render() {
    let filters = [];
    this.filterHelper.definedFilters().map(filter => {
      if (filter.type === 'checkboxes') {
        filters.push(
          <FilterCheckboxes form={this.props.form}
                            onFilter={this.props.onFilter}
                            title={filter.title}
                            fieldName={filter.fieldName}
          />
        )
      } else if(filter.type === 'slider'){
        filters.push(
          <FilterSlider reset={this.props.forceResetSlider}
                        onFilter={this.props.onFilter}
                        title={filter.title}
                        fieldName={filter.fieldName}
          />
        )
      }
    });
    return (
      <div className="filter">
        <div className="filter__inner">
          <div className="filter__header">
            <h2 className="filter__title">
              <Trans i18nKey="filter_column.filters">Filters</Trans>
            </h2>
            <button className="filter__close button js-filter-close">
              <span className="button__icon">
                <Icon iconId="cross"/>
              </span>
              <span className="button__text">
                <Trans i18nKey="filter_column.label_close">Close</Trans>
              </span>
            </button>
          </div>
          <div className="filter__body">
            <ActiveFilters removeFilter={(filterName, filterValue) => this.props.removeFilter(filterName, filterValue)}
                           removeAllFilters={this.props.removeAllFilters}
                           filterLabels={this.props.filterLabels}
                           filterObjects={this.props.filterObjects}
            />
            {/*<FilterCloud filterObjects={this.props.filterObjects}/>*/}
            {filters}
            {/*<FilterInput />*/}
          </div>
          <div className="filter__submit">
            <button className="button button--primary js-filter-close">
              <span className="button__icon">
                <Icon iconId="chevron-right"/>
              </span>
              <span className="button__text">
                <Trans i18nKey="filter_column.label_apply">Show results</Trans>
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default FilterColumn;
